var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio-bar',{attrs:{"isPlaying":_vm.isMessageAudioPlaying,"onPlayAudio":_vm.playAudio,"onPauseAudio":_vm.pauseAudio,"onSetCurrentPosition":_vm.setCurrentPosition,"currentTime":_vm.audioCurrentTime,"duration":_vm.duration,"isDisabled":!_vm.isMessageAudioSelectedForPlayback}})
}
var staticRenderFns = []

export { render, staticRenderFns }